import dayjs from 'dayjs';

export const normalizeDateValue = (
  value: unknown,
  originalValue: unknown
): Date | null => {
  if (
    originalValue === null ||
    originalValue === undefined ||
    originalValue === ''
  ) {
    return null;
  }

  if (dayjs.isDayjs(originalValue)) {
    const d = originalValue.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (originalValue instanceof Date) {
    return Number.isNaN(originalValue.getTime()) ? null : originalValue;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  return null;
};
